// Carry Roll Shared Types — the contract between frontend, backend, and MCP.
// PSD §3.1–3.3. Canonical SI units internally.
// This package is dependency-free; shared-logic and api-server depend on it.
// ── Categorical inputs / outputs (§3.1) ──────
export var Firmness;
(function (Firmness) {
    Firmness["Firm"] = "firm";
    Firmness["Normal"] = "normal";
    Firmness["Soft"] = "soft";
})(Firmness || (Firmness = {}));
export var SurfaceMoisture;
(function (SurfaceMoisture) {
    SurfaceMoisture["Dry"] = "dry";
    SurfaceMoisture["Normal"] = "normal";
    SurfaceMoisture["Wet"] = "wet";
})(SurfaceMoisture || (SurfaceMoisture = {}));
export var LandingSurface;
(function (LandingSurface) {
    LandingSurface["Fairway"] = "fairway";
    LandingSurface["Rough"] = "rough";
    LandingSurface["Green"] = "green";
})(LandingSurface || (LandingSurface = {}));
export var ClubCategory;
(function (ClubCategory) {
    ClubCategory["Driver"] = "driver";
    ClubCategory["Wood"] = "wood";
    ClubCategory["Hybrid"] = "hybrid";
    ClubCategory["Iron"] = "iron";
    ClubCategory["Wedge"] = "wedge";
})(ClubCategory || (ClubCategory = {}));
export var InputMode;
(function (InputMode) {
    InputMode["Basic"] = "basic";
    InputMode["Advanced"] = "advanced";
})(InputMode || (InputMode = {}));
export var DistanceMode;
(function (DistanceMode) {
    DistanceMode["Carry"] = "carry";
    DistanceMode["Total"] = "total";
})(DistanceMode || (DistanceMode = {}));
export var Fidelity;
(function (Fidelity) {
    Fidelity["Basic"] = "basic";
    Fidelity["Full"] = "full";
})(Fidelity || (Fidelity = {}));
export var ShotShape;
(function (ShotShape) {
    ShotShape["Straight"] = "straight";
    ShotShape["Draw"] = "draw";
    ShotShape["Fade"] = "fade";
    ShotShape["Hook"] = "hook";
    ShotShape["Slice"] = "slice";
})(ShotShape || (ShotShape = {}));
export var TrajectoryProfile;
(function (TrajectoryProfile) {
    TrajectoryProfile["Low"] = "low";
    TrajectoryProfile["Mid"] = "mid";
    TrajectoryProfile["High"] = "high";
})(TrajectoryProfile || (TrajectoryProfile = {}));
export var SessionType;
(function (SessionType) {
    SessionType["Indoor"] = "indoor";
    SessionType["Outdoor"] = "outdoor";
})(SessionType || (SessionType = {}));
export var ConfidenceLevel;
(function (ConfidenceLevel) {
    ConfidenceLevel["Measured"] = "measured";
    ConfidenceLevel["Mixed"] = "mixed";
    ConfidenceLevel["Assumed"] = "assumed";
})(ConfidenceLevel || (ConfidenceLevel = {}));
//# sourceMappingURL=index.js.map